import Vue from 'vue'
import Router from 'vue-router';
import Cookie from "js-cookie";
import { userTokenName, companyName, loginUser, loginRole } from '@/utils/auth.js';
Vue.use(Router)

const routes = [
    //首页
    {
        path: '/',
        redirect: '/index',
    },
    {
        path: '/index',
        name: 'index',
        meta: { access: 'index', title: '首页' },
        component: () => import('@/views/index.vue'),
    },
    {
        path: '/register',
        name: 'register',
        meta: { access: 'register', title: '注册' },
        component: () => import('@/views/register.vue'),
    },
    {
        path: '/infolist/:tid(\\w+)',
        name: 'infolist',
        meta: { access: 'infolist', title: '动态要闻' },
        component: () => import('@/views/infoList.vue'),
    },
    {
        path: '/special/:tid(\\w+)',
        name: 'special',
        meta: { access: 'special', title: '专题专栏', },
        component: () => import('@/views/special.vue'),
    },
    {
        path: '/partyhistory/:tid(\\w+)',
        name: 'partyhistory',
        meta: { access: 'partyhistory', title: '党史学习' },
        component: () => import('@/views/partyHistory.vue'),
    },
    {
        path: '/notice/:tid(\\w+)',
        name: 'notice',
        meta: { access: 'notice', title: '公告通知' },
        component: () => import('@/views/notice.vue'),
    },
    {
        path: '/article/:aid(\\w+)',
        name: 'article',
        meta: { access: 'article', title: '' },
        component: () => import('@/views/article.vue'),
    },
    {
        path: '/about/:tid(\\w+)',
        name: 'about',
        meta: { access: 'about', title: '' },
        component: () => import('@/views/about.vue'),
    },
    {
        path: '/policy/:tid(\\w+)',
        name: 'policy',
        meta: { access: 'policy', title: '政策法则' },
        component: () => import('@/views/policy.vue'),
    },
    {
        path: '/search/',
        name: 'search',
        meta: { access: 'search', title: '全文检索' },
        component: () => import('@/views/search.vue'),
    },

    {
        path: '/service/:tid(\\w+)',
        name: 'service',
        meta: { access: 'service', title: '办理服务' },
        component: () => import('@/views/service/index.vue'),
    },
    {
        path: '/communicate/:tid(\\w+)',
        name: 'communicate',
        meta: { access: 'communicate', title: '互动交流' },
        component: () => import('@/views/communicate/index.vue'),
    },
    {
        path: '/replydetail/:aid(\\w+)',
        name: 'replydetail',
        meta: { access: 'communicate', title: '问题回复详情' },
        component: () => import('@/views/communicate/replyDetail.vue'),
    },
    {
        path: '/downloadarticle/:aid(\\w+)',
        name: 'downloadarticle',
        meta: { access: 'downloadarticle', title: '' },
        component: () => import('@/views/article.vue'),
    },
    {
        path: '/archive/:tid(\\w+)',
        name: 'archive',
        meta: { access: 'archive', title: '医疗器械立卷审查专栏' },
        component: () => import('@/views/archive/index.vue'),
    },
    {
        path: '/userindex',
        name: 'userindex',
        meta: { access: 'userindex', title: '综合业务' },
        component: () => import('@/views/archive/userIndex.vue'),
    },
]

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: routes
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = createRouter()
// 需要登录的页面
// const loginPage = ['/manage','/editPwd']
// 不需要登录的页面
//const loginPage = ['/login', '/customerQuery']
router.beforeEach(async (to, from, next) => {
    if (!Cookie.get(userTokenName) || Cookie.get(userTokenName) == "") {
        localStorage.removeItem(userTokenName);
        localStorage.removeItem(loginUser);
        localStorage.removeItem(loginRole);
    }
    document.title = to.meta.title + '-' + (localStorage.getItem(companyName) || '河南省药品审评查验中心（河南省疫苗检查中心）');
    localStorage.setItem(
        "scrollTop",
        document.documentElement
            ? document.documentElement.scrollTop
            : document.body.scrollTop
    );
    next();
    // if (loginPage.indexOf(to.path) >= 0) {
    //     next();
    // } else {
    //     const hasToken = Cookie.get(userTokenName);
              //     if (hasToken) {
    //         next();
    //     } else {
    //         next({ path: '/login' });
    //     }
    // }
})

export default router